<template>
  <div id="PC">
    <div class="box one">
      <img
        :src="
          `https://web-data.zmlearn.com/image/7oHheRQUJie5AY4noYKAAk/art2.jpg?${(t = Date.now())}`
        "
        alt=""
      />
    </div>
    <div class="box two">
      <img
        :src="
          `https://web-data.zmlearn.com/image/2ndmjF8WK6WpQNxjRAnFJi/koucai2.jpg?${(t = Date.now())}`
        "
        alt=""
      />
      <!-- <div class="btn">
        <img
          v-for="item in linkArr"
          ref="subnav"
          :key="item.id"
          :src="item.img"
          @click="handleLink(item.id)"
          @mouseover="mouseOver(item.id)"
          @mouseleave="mouseLeave"
        />
        <i :style="{ transform: `translateX(${activeLineLeft}px)` }"></i>
      </div> -->
    </div>
    <div class="box three">
      <img
        :src="
          `https://web-data.zmlearn.com/image/8SWPFfBuZHLvmUm452CgPb/koucai3.png?${(t = Date.now())}`
        "
        alt=""
      />
    </div>
    <div class="box four">
      <img
        :src="
          `https://web-data.zmlearn.com/image/s84B9ryRmsfDz5t4CXcDCm/koucaibox.jpg?${(t = Date.now())}`
        "
        alt=""
      />
      <div class="box-item">
        <img
          :src="
            `https://web-data.zmlearn.com/image/9P5drvkjMC5TuEfF5eovmP/top.png?${(t = Date.now())}`
          "
          alt=""
        />
        <div class="jump-img">
          <img
            class="is-show"
            :class="imgShow === 'L1' ? 'active' : ''"
            :src="
              `https://web-data.zmlearn.com/image/nPE5LEq76ZrMXmVKcsLp1N/L1.png?${(t = Date.now())}`
            "
            alt=""
          />
          <img
            class="is-show"
            :class="imgShow === 'L2' ? 'active' : ''"
            :src="
              `https://web-data.zmlearn.com/image/gw3JJSU5nHGf7qmyAfSpZZ/L2.png?${(t = Date.now())}`
            "
            alt=""
          />
          <img
            class="is-show"
            :class="imgShow === 'L3' ? 'active' : ''"
            :src="
              `https://web-data.zmlearn.com/image/k5HL4KBBJ5aFJJsnj6ds6e/L3.png?${(t = Date.now())}`
            "
            alt=""
          />
          <div class="jump-btn">
            <img
              src="https://web-data.zmlearn.com/image/7ApU424vz7CrU8QQjvFaWv/l1.png"
              alt=""
              @click="imgShow = 'L1'"
            />
            <img
              src="https://web-data.zmlearn.com/image/nnHYm4uKoZhMXXmhfjz9V8/l2.png"
              alt=""
              @click="imgShow = 'L2'"
            />
            <img
              src="https://web-data.zmlearn.com/image/puPB5FBmKMVAdkvHe1eSFZ/l3.png"
              alt=""
              @click="imgShow = 'L3'"
            />
          </div>
          <div class="right" @click="handleGo(1)">
            <img
              src="https://web-data.zmlearn.com/image/bEZ9mxWiuwymr4PDZoRy4T/%E5%8F%A3%E6%89%8D%E7%BD%91%E9%A1%B5-%E6%94%B9-09.png"
              alt=""
            />
          </div>
          <div class="left" @click="handleGo(-1)">
            <img
              src="https://web-data.zmlearn.com/image/gJudTNM6CC5xoufb6tdWrE/%E5%8F%A3%E6%89%8D%E7%BD%91%E9%A1%B5-%E6%94%B9-11.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="box five">
      <img
        :src="
          `https://web-data.zmlearn.com/image/coyWF18MAVtzvbUQqfTZEP/koucai5.jpg?${(t = Date.now())}`
        "
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data () {
    return {
      linkArr: [
        {
          id: 1,
          img:
            'https://web-data.zmlearn.com/image/4yVrEHfmys2JZdU9fTSF1n/ms.png'
        },
        {
          id: 2,
          img:
            'https://web-data.zmlearn.com/image/bqZGH6BQprEenUtA67brJm/kc.png'
        },
        {
          id: 3,
          img:
            'https://web-data.zmlearn.com/image/8aY4Xr5sRskGHVrHVjf84C/bc.png'
        }
      ],
      activeLineLeft: '275',
      imgShow: 'L1'
    }
  },
  filters: {
    itemFilter (v) {
      return v[0].type === 'p' ? v[0].val : v[1].val
    }
  },
  mounted () {
  },
  methods: {
    handleGo (item) {
      if (item === 1) {
        switch (this.imgShow) {
          case 'L1':
            this.imgShow = 'L2'
            break
          case 'L2':
            this.imgShow = 'L3'
            break
          default:
            this.imgShow = 'L1'
            break
        }
      } else {
        switch (this.imgShow) {
          case 'L1':
            this.imgShow = 'L3'
            break
          case 'L2':
            this.imgShow = 'L1'
            break
          default:
            this.imgShow = 'L2'
            break
        }
      }
    },
    handleLink (id) {
      switch (id) {
        case 1:
          // this.$router.push('/zmArt')
          break
        case 2:
          // this.$router.push('/zmKouCai')
          break
        case 3:
          // this.$router.push('/zmProgram')
          break
        default:
          break
      }
    },
    mouseLeave () {
      this.activeLineLeft = '275'
    },
    mouseOver (item) {
      if (item === 1) {
        this.activeLineLeft = '30'
      } else if (item === 2) {
        this.activeLineLeft = '275'
      } else {
        this.activeLineLeft = '520'
      }
    }
  }
}
</script>
<style>
.box {
  position: relative;
  width: 100%;
}
img {
  display: block;
  width: 100%;
}
.two .btn {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
}
.two .btn i {
  position: absolute;
  bottom: 20px;
  left: 110px;
  width: 14px;
  height: 20px;
  background: #000;
  border-radius: 2px;
  transition: transform 0.4s ease;
}
.two .btn img {
  cursor: pointer;
  margin: 20px;
  width: 15%;
}

.four {
  position: relative;
  width: 100%;
}

.four .box-item{
  position: absolute;
  width: 65%;
  height: 80%;
  top: 16%;
  left: 50%;
  transform: translateX(-50%);
}

.four .box-item .jump-img{
  position: relative;
  height: 50%;
  width: 100%;
}

.four .box-item .jump-img .is-show {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.5s ease;
}

.four .box-item .jump-img .active{
  opacity: 100;
}

.four .box-item .jump-img .jump-btn {
  position: absolute;
  width: 100%;
  top: 13%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.four .box-item .jump-img .jump-btn img {
  width: 16%;
  cursor: pointer;
}

.four .box-item .jump-img .right {
  position: absolute;
  z-index: 10;
  cursor: pointer;
  width: 4%;
  right: 3%;
  top: 50%;
  transform: translateY(-50%);
}

.four .box-item .jump-img .left {
  position: absolute;
  z-index: 10;
  cursor: pointer;
  width: 4%;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);
}
</style>
